import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const { accessToken } = useAuth();

  const getCurrentToken = () => accessToken || localStorage.getItem('auth-token');

  const hasValidToken = () => {
    const token = getCurrentToken();
    if (!token) {
      return false;
    }

    try {
      const decodedToken = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
      return decodedToken.exp > Date.now() / 1000;
    } catch (error) {
      return false;
    }
  };

  const loginPath = location.pathname.startsWith('/admin')
    ? '/admin/login-admin'
    : '/login';

  return hasValidToken() ? (
    children // Renderiza el componente hijo si está autenticado
  ) : (
    <Navigate to={loginPath} replace state={{ from: location }} />
  );
};

export default PrivateRoute;